module.exports = __webpack_public_path__ + "img/expired.b64a0285.svg";